import {useLazyFetchStripePaymentSummaryQuery} from 'components/customer/Confirmation/store/gatewayApi';
import {PaymentType} from 'components/manufacturer/Payments/entity/Deposit';
import {PaymentMethodType} from 'components/manufacturer/Payments/entity/Setting';
import {useCallback} from 'react';
import {store} from 'store/customer';

export const useUpdatePaymentIntent = () => {
    const [updatePaymentIntent] = useLazyFetchStripePaymentSummaryQuery();

    const updateIntent = useCallback(
        async (
            intentPaymentMethod: PaymentMethodType,
            jobId: number,
            manufacturerId: number
        ) => {
            if (store) {
                const state = store.getState();

                if (state.confirmation.paymentType == PaymentType.GATEWAY) {
                    const paymentMethod = state.confirmation.paymentMethod;

                    if (paymentMethod != intentPaymentMethod) {
                        const confirmationToken =
                            state.confirmation.confirmationToken;
                        const paymentIntentId =
                            state.confirmation.paymentIntentId;

                        if (confirmationToken && paymentIntentId) {
                            return await updatePaymentIntent({
                                confirmationToken,
                                paymentIntentId,
                                manufacturerId: manufacturerId,
                                paymentMethod,
                                jobId,
                            });
                        }
                    }
                }
            }
        },
        []
    );

    return {
        updateIntent,
    };
};
